// removed by extract-text-webpack-plugin
module.exports = {"root":"src-components-Practice-Main-title-root-168XY","title":"src-components-Practice-Main-title-title-2uKon","notice":"src-components-Practice-Main-title-notice-3fv-w","indicator":"src-components-Practice-Main-title-indicator-1Mlj5","intro":"src-components-Practice-Main-title-intro-UcCZm"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Practice/Main/title.css
 ** module id = 271
 ** module chunks = 0
 **/